import axiosClient from './axiosClient'

export const markWatched = async (): Promise<{ success: boolean }> => {
  await axiosClient.put('/viewfi/update-ad-required')
  return { success: true }
}

export const getRewardBoosters = async () => {
  const response = await axiosClient.get('/viewfi/reward-boosters')
  return response.data
}

export const claimReward = async () => {
  const response = await axiosClient.put('/viewfi/increment-view')
  return response.data
}

export const getTrackView = async (): Promise<{ is_watched: boolean; daily_ad_enabled: boolean; claim_ad_required: boolean; ad_view_count?: number; limit?: number }> => {
  const response = await axiosClient.post('/viewfi/track-view')
  return response.data
}

